import { render, staticRenderFns } from "./toppings-modal.vue?vue&type=template&id=3a2c0b4e&scoped=true"
import script from "./toppings-modal.vue?vue&type=script&lang=js"
export * from "./toppings-modal.vue?vue&type=script&lang=js"
import style0 from "./toppings-modal.vue?vue&type=style&index=0&id=3a2c0b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2c0b4e",
  null
  
)

export default component.exports